import { render, staticRenderFns } from "./zzjg.vue?vue&type=template&id=2a9df405&scoped=true&"
import script from "./zzjg.vue?vue&type=script&lang=js&"
export * from "./zzjg.vue?vue&type=script&lang=js&"
import style0 from "./zzjg.vue?vue&type=style&index=0&id=2a9df405&scoped=true&lang=css&"
import style1 from "./zzjg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9df405",
  null
  
)

export default component.exports